module.exports = __webpack_public_path__ + "img/76.005180c6.jpg";